import {
  ActivityDesignMeaning,
  BrandDesignMeaning,
  DefaultDesignMeaning,
  ImportanceDesignMeaning,
  SentimentDesignMeaning,
} from '@/types/design-semantics';
import { RegisteredIcon } from '@/lib/icons';

type AllMeanings =
  | SentimentDesignMeaning
  | ImportanceDesignMeaning
  | ActivityDesignMeaning
  | BrandDesignMeaning
  | DefaultDesignMeaning;

export const MeaningIcons: Record<AllMeanings, RegisteredIcon> = {
  default: 'custom/i',
  neutral: 'custom/i',
  positive: 'feather/check',
  negative: 'feather/x',
  warning: 'custom/exclamation',
  info: 'custom/i',
  active: 'custom/i',
  inactive: 'custom/i',
  primary: 'custom/i',
  accent: 'custom/i',
  high: 'feather/arrow-up',
  medium: 'feather/arrow-right',
  low: 'feather/arrow-down',
};
